import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/apply/plugin/list',
    name: 'pluginList',
    component: () => import('@/views/apply/plugin/plugin_list'),
    meta: {
      title: i18n.t('router.plugin.plugin_list'),
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/plugin.js